<div class="input-grid-gaps grid-1col">
    <app-input-file-btn
        #files
        [label]="'user.experience.fields.upload' | translate"
        [auto]="false"
        [acceptTypes]="'image/*,application/pdf'"
        [categoryCode]="DefaultCategoryTypeEnum.TRAININGS"
        [fileName]="this.fileName"
        (selected)="onSelect($event)"
    />
    @if (experience?.file && !selectedFiles.length) {
        <app-file-link-component
            [file]="{ path: experience.file, name: experience.file }"
            [icon]="true"
        ></app-file-link-component>
    }
    <app-date-input
        [form]="form"
        id="date"
        label="user.experience.fields.date"
    ></app-date-input>
    <app-number-input
        [form]="form"
        id="hours"
        label="user.experience.fields.hours"
        icon="pi-hourglass"
    ></app-number-input>
    <app-text-input
        [form]="form"
        id="name"
        label="inputs.title"
    ></app-text-input>
    <app-check-input
        [form]="form"
        id="countInEducation"
        label="user.experience.fields.countInEducation"
    ></app-check-input>
    @if (countInEducation()) {
        <app-select-input
            [form]="form"
            id="employmentTypeEducationId"
            label="user.experience.fields.educationType"
            [staticOptions]="educationGroups()"
            [group]="true"
            [showClear]="false"
            [showHelpText]="true"
            [helpText]="educationHelpText()"
            idField="id"
            valueKey="id"
            labelKey="name"
            filterBy="name,description"
        ></app-select-input>
    }
</div>
